import { memo } from 'react';

import { ReadOnlyBanner } from '@/components/atoms/ReadOnlyBanner/ReadOnlyBanner';
import { cn } from '@/lib/utils';

type ContentProps = {
  children: React.ReactNode;
  gutters?: boolean;
  noGutters?: boolean;
  whiteBackground?: boolean;
  readOnly?: boolean;
  /** For pages that scroll internally: stops the wrapper from clipping focus rings at its edges */
  overflowVisible?: boolean;
  className?: string;
};

const PageContentWrapper = memo(
  ({
    children,
    readOnly,
    gutters = false,
    noGutters = false,
    whiteBackground = false,
    overflowVisible = false,
    className,
  }: ContentProps) => {
    return (
      <div
        className={cn(
          'flex h-full min-h-0 flex-col bg-subtle',
          !overflowVisible && 'overflow-hidden'
        )}
      >
        {readOnly && <ReadOnlyBanner />}
        <div
          className={cn(
            'min-h-0 flex-1 bg-subtle px-5 pt-5 pb-20',
            overflowVisible ? 'overflow-visible' : 'overflow-x-hidden overflow-y-auto',
            { 'bg-background': whiteBackground },
            { 'p-0': noGutters },
            { 'px-9 py-5': gutters },
            className
          )}
        >
          {children}
        </div>
      </div>
    );
  }
);

PageContentWrapper.displayName = 'PageContentWrapper';

export default PageContentWrapper;
